import {Component, forwardRef, HostListener, Input} from '@angular/core';
import { NG_VALUE_ACCESSOR} from '@angular/forms';
import {MaterialInputComponent} from './material-input.component';

@Component({
    selector: 'app-material-input-digits',
    templateUrl: './material-input-digits.component.html',
    styleUrls: ['./material-input-digits.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MaterialInputDigitsComponent),
            multi: true
        }
    ],
    standalone: false
})
export class MaterialInputDigitsComponent extends MaterialInputComponent {

  public displayed_value = '';
  public potential_shortcut = null;

  private shift_pressed = false;
  @Input('firstString') public firstString = '';
  @Input() public multiplyThousand = true;

  static prepareDigits(value) {

    if (value === null) {
      return '';
    }

    return value.replace(/\B(?=(\d{3})+(?!\d))/g, '');
  }

  onChangeDigit(event, target) {
    if (event.keyCode === 13 || event.keyCode === 16) {
      return;
    }

    let digits = target.value.match(/\d/g);

    if (digits) {
      digits = digits.join('');
    }

    target.value = MaterialInputDigitsComponent.prepareDigits(digits);
    this.current_value = digits;

    if (this.getShortcutResult()) {
      this.potential_shortcut = MaterialInputDigitsComponent.prepareDigits(this.getShortcutResult());
    }
    else {
      this.potential_shortcut = null;
    }
  }

  writeValue(value: any) {
    super.writeValue(value);

    let digits = value.toString().match(/\d/g);

    if (digits) {
      digits = digits.join('');
    }

    this.displayed_value = MaterialInputDigitsComponent.prepareDigits(digits);
  }

  onBlur(event) {
    this.potential_shortcut = null;
  }

  onEnter(event) {
    if (!this.shift_pressed || !this.focus || !this.current_value || !this.potential_shortcut) {
      return;
    }
    event.preventDefault();
    this.displayed_value = '';
    setTimeout(_ => this.writeValue(this.getShortcutResult()), 50);
    this.potential_shortcut = null;
  }

  private getShortcutResult() {
    if (!this.current_value) {
      return null;
    }

    const value_length = this.current_value.toString().length;

    if (value_length >= 1 && value_length < 6) {
      return this.current_value.toString() + new Array(7 - value_length).fill('0').join('');
    }

    return null;
  }

  @HostListener('window:keydown', ['$event'])
  private hotkeysDown(event) {
    if (event.keyCode === 16) {
      this.shift_pressed = event.shiftKey;
    }

    if (event.keyCode === 13) {
      this.onEnter(event);
    }
  }

  @HostListener('window:keyup', ['$event'])
  private hotkeysUp(event) {
    if (event.keyCode === 16) {
      this.shift_pressed = event.shiftKey;
    }
  }

}
